import { get, post } from "../axios/http"
import qs from 'qs'

export const getAppList = (appId) => get(`/api/app/detail?id=${appId}&getWorksheetInfo=true`) 

export const updateApp = (data) => post('/api/app/update', data)

export const getWorksheetInfo = (worksheetId) => get(`/api/app/worksheet/info/get?id=${worksheetId}`)

export const getFilterDataList = (data) => post('/api/app/worksheet/rows/list', data)

export const updateWorksheet = (data) => post('/api/app/worksheet/info/update', data)

export const addRow = (data) => post('/api/app/worksheet/rows/save', data)

export const getRow= (worksheetId, rowId) => get(`/api/app/worksheet/rows/get?worksheetId=${worksheetId}&rowId=${rowId}`)

export const delRow = (rowId,worksheetId) => post(`/api/app/worksheet/rows/delete?rowId=${rowId}&worksheetId=${worksheetId}`)
export const delRowBatch = (data) => post('/api/app/worksheet/rows/batch-delete',data)

export const updateRow = (data) => post('/api/app/worksheet/rows/update', data)

export const getShareFilterDataList = (data) => post('/api/app/worksheet/rows/list', data, { headers:{'Content-Type': 'application/json','X-Mode': 'share'} })

export const getAppAuth = (appId) => get(`/api/v2/User/getAppAuth?visualId=${appId}`)

export const getShortcut = () => get('/api/app/worksheet/shortcut/get')
export const addShortcut = (data) => post('/api/app/worksheet/shortcut/save', data)
export const delShortcut = (data) => post('/api/app/worksheet/shortcut/delete', qs.stringify(data), { headers:{'Content-Type': 'application/x-www-form-urlencoded'} })

export const getPrintList = (worksheetId) => get(`/api/app/worksheet/print/list?worksheetId=${worksheetId}`)
export const getPrintTemplate = (data) => post('/api/app/worksheet/print/render', data, { headers:{'Content-Type': 'application/json'} })